export const AUTH_ACTION_TYPES = {
  RESET_AUTH_STATE: 'RESET_AUTH_STATE',
  SIGNIN: 'SIGNIN',
} as const;
